import { memo } from 'react';

import type { PlanRevampIconProperties } from './types';

/**
 * Blox-Design plan toolbar — filter funnel (node 75644:10724).
 */
const PlanToolbarFilterIcon = ({
  width = 16,
  height = 16,
  color = 'currentColor',
}: PlanRevampIconProperties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M21 3H5C4.447 3 4 3.447 4 4v2.59c0 .523.213 1.037.583 1.407L10 13.414V21c0 .347.18.668.475.851.635.95.817 1 1 1 .153 0 .306-.035.447-.105l4-2c.786-.429 1-.775 1-1.179v-5.586l5.417-5.417C21.787 7.627 22 7.113 22 6.59V4c0-.553-.447-1-1-1Zm-6.707 9.293a.999.999 0 0 0-.293.707V18.382l-2 1V13a1 1 0 0 0-.293-.707L6 6.59V5h14l.002 1.583-5.709 5.71Z'
      fill={color}
    />
  </svg>
);

export default memo(PlanToolbarFilterIcon);
